import { AutocompleteInput } from 'react-admin';
import { useState, useMemo, useEffect } from 'react';
import { goApi } from '../../../services';

export const EcomCategoriesAutoComplete = (props: any) => {
    const [searchText, setSearchText] = useState('');
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchCategories = async () => {
            setIsLoading(true);
            try {
                const params = searchText ? `?name=${encodeURIComponent(searchText)}` : '';
                const response = await goApi.get(`/ecom/categories${params}`);
                const categories = response.data?.items || [];
                setData(categories);
            } catch (error) {
                console.error('Failed to fetch categories', error);
                setData([]);
            } finally {
                setIsLoading(false);
            }
        };
        fetchCategories();
    }, [searchText]);

    const choices = useMemo(() => {
        if (selectedItem && !data.find((item: any) => item.id === selectedItem.id)) {
            return [selectedItem, ...data];
        }
        return data;
    }, [data, selectedItem]);

    return (
        <AutocompleteInput
            {...props}
            source={props.source || 'categoryId'}
            fullWidth
            label={props.label || 'Category'}
            choices={choices}
            optionText="name"
            optionValue="id"
            loading={isLoading}
            setFilter={value => setSearchText(value)}
            onChange={value => {
                const selected = choices.find((item: any) => item.id === value);
                if (selected) {
                    setSelectedItem(selected);
                }
                if (props.onChange) {
                    props.onChange(value);
                }
            }}
            debounce={500}
            shouldRenderSuggestions={(val: string) => {
                return val.trim().length >= 0;
            }}
        />
    );
};
